import React, { Component } from 'react';
import { Layout, Row, Col, Card, Table, Switch, Icon, notification, Input, Alert } from 'antd';
import { featureFlagsService } from '../../services';

const { Content } = Layout;

class FeatureFlags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      flags: [],
      query: '',
    };
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ loading: true });
    featureFlagsService
      .getInstitutionFlags()
      .then((flags) => {
        this.setState({ flags, loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
        const data = error && error.data ? error.data : null;
        const msg = typeof data === 'string' ? data : (data && data.message) || 'Falha ao carregar flags';
        notification.error({ message: msg });
      });
  };

  handleSearchChange = (e) => {
    this.setState({ query: e.target.value });
  };

  handleToggle = (record, active) => {
    featureFlagsService
      .toggleFlag(record.name, active)
      .then(() => {
        this.setState((prevState) => {
          const updated = prevState.flags.map((f) => {
            if (f.name === record.name) return { ...f, value: active };
            return f;
          });
          return { flags: updated };
        });
        notification.success({ message: `Flag ${record.name} ${active ? 'ativada' : 'desativada'}` });
      })
      .catch((error) => {
        const data = error && error.data ? error.data : null;
        const msg = typeof data === 'string' ? data : (data && data.message) || 'Falha ao atualizar flag';
        notification.error({ message: msg });
      });
  };

  render() {
    const { flags, loading, query } = this.state;
    const q = (query || '').toLowerCase();
    const filteredFlags = q
      ? flags.filter((f) => {
        const name = (f.name || '').toLowerCase();
        const desc = (f.description || '').toLowerCase();
        return name.includes(q) || desc.includes(q);
      })
      : flags;
    const columns = [
      {
        title: 'Nome',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Descrição',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Tarefa',
        dataIndex: 'task_url',
        key: 'task_url',
        render: (url, record) => {
          if (!url) return '-';

          return (
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Abrir tarefa da flag ${record.name}`}
            >
              <Icon type="link" />
            </a>
          );
        },
      },
      {
        title: 'Status',
        dataIndex: 'value',
        key: 'value',
        render: (value, record) => (
          <Switch
            checkedChildren={<Icon type="check" />}
            unCheckedChildren={<Icon type="close" />}
            checked={!!value}
            onChange={(checked) => this.handleToggle(record, checked)}
          />
        ),
      },
    ];

    return (
      <Content>
        <Row>
          <Col xs={24} lg={12}>
            <h1 className="title">Feature Flags</h1>
          </Col>
          <Col xs={24} lg={12}>
            <div style={{ marginBottom: 10 }}>
              <Input.Search
                placeholder="Buscar por nome ou descrição"
                value={query}
                onChange={this.handleSearchChange}
                allowClear
                style={{ width: '100%' }}
                disabled={loading}
              />
            </div>
          </Col>
          <Col span={24}>
            <Table
              rowKey={(record) => record.id || record.name}
              loading={loading}
              dataSource={filteredFlags}
              columns={columns}
              pagination={false}
            />
          </Col>
        </Row>
      </Content>
    );
  }
}

export default FeatureFlags;
